// extracted by mini-css-extract-plugin
export default {"container":"UserMenu_container__xPzvm","headerItem":"UserMenu_headerItem__3AyNl","disabled":"UserMenu_disabled__T7J6g","badge":"UserMenu_badge__0Nt02"};